export default __webpack_public_path__ + "static/noImageNews-d23102ff17b0b78e7c06e9a13010acbb.png";